import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

interface ThinCityPageProps {
  city: string;
  state: string;
}

const ThinCityPage: React.FC<ThinCityPageProps> = ({ city, state }) => {
  return (
    <>
      <SEOHead
        title={`AI Consulting ${city} | Agility`}
        description={`AI consulting services in ${city}, ${state}. Agility delivers production-ready AI solutions across automation, data engineering, and machine learning.`}
        noindex={true}
      />
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="text-center max-w-lg">
          <h1 className="text-3xl font-bold mb-4">AI Consulting in {city}</h1>
          <p className="text-gray-600 mb-6">
            Agility serves clients across the United States, including {city}. Explore our full
            US AI consulting services for pricing, case studies, and how we deploy production AI
            in 3–8 weeks.
          </p>
          <Link
            to="/ai-consulting-company-usa"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            View US AI Consulting →
          </Link>
        </div>
      </div>
    </>
  );
};

export default ThinCityPage;
